import { FormField, FormInput, FormSelect } from "web-design-system";
import { getFieldLabel } from "creso-core/utils";
import { useCountryOptions, useStateOptions } from "creso-core/hooks";
import { Section } from "./section";
import { useAccountForm } from "./context";

export function AddressSection() {
  const countryOptions = useCountryOptions();
  const stateOptions = useStateOptions();

  const { form, isEditing } = useAccountForm();

  const dirtyFields = Object.entries(form.formState.dirtyFields.address || {})
    .filter(([, v]) => v)
    .map(([k]) => getFieldLabel(k));

  return (
    <Section title="Address" dirtyFields={dirtyFields}>
      <div className="grid gap-6 grid-cols-4">
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          control={form.control}
          name="address.line1"
          disabled={!isEditing}
          render={({ field }) => (
            <FormInput placeholder="Address line 1" {...field} />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          control={form.control}
          name="address.line2"
          render={({ field }) => (
            <FormInput
              placeholder="Address line 2"
              disabled={!isEditing}
              {...field}
              value={field.value || ""}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2"
          control={form.control}
          name="address.line3"
          render={({ field }) => (
            <FormInput
              placeholder="Address line 3 (optional)"
              disabled={!isEditing}
              {...field}
              value={field.value || ""}
            />
          )}
        />
        <div className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-2" />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          control={form.control}
          name="address.country"
          render={({ field }) => (
            <FormSelect
              label="Country"
              options={countryOptions}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          control={form.control}
          name="address.postal_code"
          render={({ field }) => (
            <FormInput label="Postal code" disabled={!isEditing} {...field} />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          control={form.control}
          name="address.state"
          render={({ field }) => (
            <FormSelect
              label="State"
              options={stateOptions}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-4 sm:col-span-4 md:col-span-2 lg:col-span-1"
          control={form.control}
          name="address.city"
          render={({ field }) => (
            <FormInput label="City or Town" disabled={!isEditing} {...field} />
          )}
        />
      </div>
    </Section>
  );
}
